import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=22cc73be"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports